// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconEdit_cursor__6sdqV","root":"IconEdit_root__GopWH","pencil":"IconEdit_pencil__1AeJ0"};